import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import { PopoverOptionItem } from "../ChatiaPopover";

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: "flex",
        flexDirection: "column",
        gap: 12,
    },
    searchInput: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 12,
            fontSize: 13,
        },
    },
    tagsList: {
        maxHeight: 240,
        overflowY: "auto",
        ...theme.scrollbarStylesSoft,
    },
}));

export function TagsKanbanContainer({ ticket }) {
    const classes = useStyles();
    const [tags, setTags] = useState([]);
    const [selected, setSelected] = useState(null);
    const [search, setSearch] = useState("");

    useEffect(() => {
        let isMounted = true;
        loadTags(isMounted).then((loadedTags) => {
            if (isMounted && ticket.tags && ticket.tags.length > 0 && loadedTags) {
                const found = loadedTags.find(t => t.id === ticket.tags[0].id);
                if (found) setSelected(found.id);
            }
        });
        return () => { isMounted = false; };
    }, [ticket.tags]);

    const loadTags = async (isMounted) => {
        try {
            const { data } = await api.get(`/tags/list`, { params: { kanban: 1 } });
            if (isMounted !== false) setTags(data);
            return data;
        } catch (err) {
            toastError(err);
            return [];
        }
    };

    const handleSelect = async (tag) => {
        try {
            if (ticket.tags && ticket.tags.length > 0) {
                await api.delete(`/ticket-tags/${ticket.id}`);
            }
            if (tag && (!selected || selected !== tag.id)) {
                await api.put(`/ticket-tags/${ticket.id}/${tag.id}`);
                setSelected(tag.id);
            } else {
                setSelected(null);
            }
        } catch (err) {
            toastError(err);
        }
    };

    const filtered = tags.filter(t =>
        t.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className={classes.wrapper}>
            {tags.length > 5 && (
                <TextField
                    size="small"
                    variant="outlined"
                    placeholder={i18n.t("Buscar etapa...")}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className={classes.searchInput}
                    fullWidth
                />
            )}
            <div className={classes.tagsList}>
                {filtered.map(tag => (
                    <PopoverOptionItem
                        key={tag.id}
                        label={tag.name}
                        selected={selected === tag.id}
                        onClick={() => handleSelect(tag)}
                    />
                ))}
            </div>
        </div>
    );
}
